// Board bet types — result is [D]ABC: A/B/C are ALWAYS the last three digits, D is the leading 4th digit (4D only)
export const BOARD_TYPES = {
  A: { digits: 1, group: "single", label: "A Single (hundreds digit)", positions: ["A"] },
  B: { digits: 1, group: "single", label: "B Single (tens digit)", positions: ["B"] },
  C: { digits: 1, group: "single", label: "C Single (last digit)", positions: ["C"] },
  ALL: { digits: 1, group: "single", label: "All-Board Single", positions: ["★"], tag: "ALL BOARD" },
  AB: { digits: 2, group: "double", label: "AB (hundreds + tens)", positions: ["A", "B"] },
  BC: { digits: 2, group: "double", label: "BC (tens + last)", positions: ["B", "C"] },
  AC: { digits: 2, group: "double", label: "AC (hundreds + last)", positions: ["A", "C"] },
  "3D": { digits: 3, group: "3d", label: "3D Direct", positions: ["A", "B", "C"], tag: "DIRECT" },
  "3D_BOX": { digits: 3, group: "3d", label: "3D Box", positions: ["A", "B", "C"], tag: "BOX" },
  "4D": { digits: 4, group: "4d", label: "4D Direct", positions: ["A", "B", "C", "D"], tag: "DIRECT" },
  "4D_BOX": { digits: 4, group: "4d", label: "4D Box", positions: ["A", "B", "C", "D"], tag: "BOX" },
};

export const BOARD_ORDER = ["A", "B", "C", "ALL", "AB", "BC", "AC", "3D", "3D_BOX", "4D", "4D_BOX"];

export const GROUPS = [
  { id: "single", label: "Singles" },
  { id: "double", label: "Doubles" },
  { id: "3d", label: "3D" },
  { id: "4d", label: "4D" },
];

// Return GROUPS sorted by an admin-defined order array (unknown ids appended).
export function orderedGroups(order) {
  if (!Array.isArray(order) || !order.length) return GROUPS;
  const map = Object.fromEntries(GROUPS.map((g) => [g.id, g]));
  const seen = new Set();
  const out = [];
  for (const id of order) {
    if (map[id] && !seen.has(id)) { out.push(map[id]); seen.add(id); }
  }
  for (const g of GROUPS) if (!seen.has(g.id)) out.push(g);
  return out;
}

export const POS_COLORS = {
  A: { ring: "#EA580C", text: "#9A3412" },
  B: { ring: "#2563EB", text: "#1E40AF" },
  C: { ring: "#16A34A", text: "#166534" },
  D: { ring: "#7C3AED", text: "#5B21B6" },
  "★": { ring: "#DC2626", text: "#991B1B" },
};

function fallbackFromDigits(d) {
  return d === 1 ? "A" : d === 2 ? "AB" : d === 3 ? "3D" : d === 4 ? "4D" : "AB";
}

export function boardKeyOf(slat) {
  return slat?.board_type && BOARD_TYPES[slat.board_type] ? slat.board_type : fallbackFromDigits(slat?.digits || 2);
}

export function boardOf(slat) {
  return BOARD_TYPES[boardKeyOf(slat)];
}

// Unique digit orderings (123 -> 6, 112 -> 3, 111 -> 1)
export function boxPermutations(num) {
  const s = String(num);
  if (s.length <= 1) return [s];
  const out = new Set();
  const walk = (prefix, rest) => {
    if (!rest.length) { out.add(prefix); return; }
    for (let i = 0; i < rest.length; i++) walk(prefix + rest[i], rest.slice(0, i) + rest.slice(i + 1));
  };
  walk("", s);
  return [...out].sort();
}

export const supportsBox = (slat) => ["3D", "4D"].includes(boardKeyOf(slat));
